import { Injectable } from '@angular/core';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  origin_lat: any;
  origin_lng: any;
  destination_lat: any;
  destination_lng: any;

  constructor() { }


  ngOnInit() {

  }

  task_activity_status = [
    {
      task_status: 1,
      status_string: 'Created'
    },
    {
      task_status: 2,
      status_string: 'Assigned'
    },
    {
      task_status: 3,
      status_string: 'Accepted'
    },
    {
      task_status: 4,
      status_string: 'Driver Start To Pickup'
    },
    {
      task_status: 5,
      status_string: 'Driver Arrived At Pickup'
    },
    {
      task_status: 6,
      status_string: 'Completed Pickup'
    },
    {
      task_status: 7,
      status_string: 'Driver Start To Dropoff'
    },
    {
      task_status: 8,
      status_string: 'Driver Arrived'
    },
    {
      task_status: 9,
      status_string: 'Completed'
    },
    {
      task_status: 10
      , status_string: 'User Cancelled'
    },
    {
      task_status: 11
      , status_string: 'Driver Cancelled'
    },
    {
      task_status: 12
      , status_string: 'Planning'
    },
    {
      task_status: 13
      , status_string: 'Planned'
    },
    {
      task_status: 14
      , status_string: 'Re-scheduled delivery'
    },
    {
      task_status: 15
      , status_string: 'Completed'
    },
    {
      task_status: 16,
      status_string: 'Order Returned'
    }
  ] as const


  task_activity_status_string(taskStatus: any) {
    console.log('--------------------- task_status ---------------------', taskStatus)
    let status = this.task_activity_status.find((key: any) => key.task_status == taskStatus)
    console.log('--------------------- status ---------------------', status)
    return status
  }

  setDateFormat: string = "h:mm A, Do MMM YYYY";

  dateFormat = (date: string) => moment(date).format(this.setDateFormat)

  toRadians(val: any) {
    var PI = 3.1415926535;
    return (val / 180.0) * PI;
  }


  getDuration(opts: any = []) {
    // let origin_lat;
    // let origin_lng;
    // let destination_lat;
    // let destination_lng;
    if (opts.length > 0) {

      if (opts.length == 2) {
        this.origin_lat = parseFloat(opts[0].lat);
        this.origin_lng = parseFloat(opts[0].lng);
        this.destination_lat = opts[1].lat;
        this.destination_lng = opts[1].lng;
      }
      // else {
      //   origin_lat = parseFloat(this.companyDetails.companyLat);
      //   origin_lng = parseFloat(this.companyDetails.companyLng);
      //   destination_lat = opts[0].lat;
      //   destination_lng = opts[0].lng;
      // }
      var R = 6371e3; // R is earth�s radius

      var origin_lat_radians = this.toRadians(this.origin_lat);
      var destination_lat_radians = this.toRadians(this.destination_lat);

      var latRadians = this.toRadians(this.origin_lat - this.destination_lat);
      var lonRadians = this.toRadians(this.origin_lng - this.destination_lng);

      var a =
        Math.sin(latRadians / 2) * Math.sin(latRadians / 2) +
        Math.cos(destination_lat_radians) *
        Math.cos(origin_lat_radians) *
        Math.sin(lonRadians / 2) *
        Math.sin(lonRadians / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      var d = R * c;
      var km = d / 1000;
      var extraTAdd = km * 100;
      km = extraTAdd / 1000 + km;
      var duration = 0;
      if (km <= 50) {
        duration = km * 2;
      } else {
        duration = km * 1;
      }

      return duration.toFixed(1);
    } else {
      return false;
    }
  }
}
